<template>
    <div id="page-top">
        <!-- Page Wrapper -->
        <div id="wrapper">
            <!-- sidebar -->
            <app-side-bar></app-side-bar>

            <!-- Content Wrapper -->
            <div id="content-wrapper" class="d-flex flex-column">
                <!-- Main Content -->
                <div id="content">
                    <!-- Topbar -->

                    <app-top-navbar></app-top-navbar>

                    <!-- Ribbon -->
                    <!-- <app-operations-ribbon></app-operations-ribbon> -->
                    <!-- / Ribbon -->

                    <!-- Begin Page Content -->
                    <div class="container-fluid">
                        <router-view></router-view>
                    </div>
                    <!-- /.container-fluid -->
                </div>
                <!-- End of Main Content -->
            </div>
            <!-- End of Content Wrapper -->
        </div>
        <!-- End of Page Wrapper -->
        <div v-if="!!person">
            <app-modal
                title="Solicitud de asistencia"
                id="assistance-warning-window"
                size="xl"
                ok-title="Emergencia Atendida"
                centered
                header-bg-variant="danger"
                body-bg-variant="danger"
                footer-bg-variant="danger"
                header-text-variant="white"
                body-text-variant="white"
                ok-only
                hide-header-close
                no-close-on-backdrop
                no-close-on-esc
                @ok="attendEmergency"
            >
                <b-row align-v="center">
                    <b-col cols="12" md="4">
                        <img src="/img/alert.webp" alt="" />
                    </b-col>
                    <b-col cols="12" md="8">
                        <span style="font-size: 3rem; font-weight: bold"
                            >{{ person.name }} ({{ person.structures.join(', ') }}) está solicitando asistencia <br
                        /></span>
                        <b-form-input autofocus style="opacity: 0"></b-form-input>
                    </b-col>
                </b-row>
            </app-modal>
        </div>
        <app-modal header-bg-variant="warning" title="Llamada entrante" id="call-window" @ok="hungUp" ok-title="Conectar" @hidden="stopRing">
            Llamada entrante de {{ caller }}
        </app-modal>
    </div>
</template>
<script>
import TopNavbar from '../components/layout/TopNavbar'
import appSideBar from '../components/layout/SideBar'
import appOperationsRibbon from '../components/controls/operations/OperationsRibbon.vue'
import toastr from 'toastr'
import { mapGetters, mapMutations } from 'vuex'
import * as mutations from '@store/_mutations'
export default {
    components: {
        appTopNavbar: TopNavbar,
        appSideBar,
        appOperationsRibbon,
    },
    data: () => ({
        person: '',
        caller: '',
        callLink: '',
        ring: null,
        callLogId: null,
        emergencyAlertRing: null,
    }),
    computed: {
        ...mapGetters(['guardNotifications']),
    },
    methods: {
        ...mapMutations({
            setguardNotifications: mutations.SET_GUARD_NOTIFICATIONS,
        }),
        listen() {
            const channel = `Workplace.${this.currentWorkplace.id}`
            window.Echo.channel(channel)
                .listen('.PanicButtonPressed', ({ person }) => {
                    this.person = person
                    this.openModal('assistance-warning-window')
                    this.emergencyAlertRing.play()
                    // toastr.success(`La persona ${person.name} esta solicitando asistencia inmediata`)
                })
                .listen('.CallToWorkplace', ({ call }) => {
                    const { person, url, callLogId } = call
                    this.caller = person
                    this.callLink = url
                    this.ring.play()
                    this.callLogId = callLogId
                    this.openModal('call-window')
                })
                .listen('.NotificationReceived', ({ notification }) => {
                    toastr.success(notification.title)

                    const allGuardNotifications = [...(this.guardNotifications || [])]
                    allGuardNotifications.push(notification)
                    this.setguardNotifications(allGuardNotifications)
                })
        },
        attendEmergency() {
            this.closeModal('assistance-warning-window')
            this.emergencyAlertRing.pause()
        },
        hungUp() {
            this.closeModal('call-window')
            this.stopRing()
            window.open(this.callLink, '_blank')
            const { data } = this.$repo.post(`intercom/${this.callLogId}/answer`, { userId: this.currentUser.id })
        },
        stopRing() {
            this.ring.pause()
            this.ring.currentTime = 0
        },
        async registerSubscription({ endpoint, publicKey, authToken }) {
            const {
                data: { error, msg },
            } = await this.$repo.post(`users/${this.currentUser.id}/push-subscriptions`, {
                endpoint,
                publicKey,
                authToken,
            })

            if (error) return toastr.error(msg)
        },
        registerSericeWorker() {
            const convertedVapidKey = urlBase64ToUint8Array(process.env.MIX_VAPID_PUBLIC_KEY)
            const registerSubscription = this.registerSubscription
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker
                    .register('serviceWorker.js')
                    .then(function (registration) {
                        if (!registration.pushManager) {
                            console.error('Push manager unavailable.')
                            return
                        }
                        Notification.requestPermission().then((permission) => {
                            if (permission === 'granted') {
                                registration.pushManager
                                    .subscribe({
                                        userVisibleOnly: true, // Always show notifications
                                        applicationServerKey: convertedVapidKey,
                                    })
                                    .then(function (subscription) {
                                        const p256dhArrayBuffer = subscription.getKey('p256dh')
                                        const authArrayBuffer = subscription.getKey('auth')

                                        // If you want these values in Base64 format for easier handling/storage:
                                        const endpoint = subscription.endpoint
                                        const publicKey = btoa(String.fromCharCode.apply(null, new Uint8Array(p256dhArrayBuffer)))
                                        const authToken = btoa(String.fromCharCode.apply(null, new Uint8Array(authArrayBuffer)))

                                        registerSubscription({
                                            endpoint,
                                            publicKey,
                                            authToken,
                                        })
                                    })
                                    .catch(function (error) {
                                        console.error('Error occurred while subscribing user:', error)
                                    })
                            } else {
                                console.error('Unable to get permission to notify.')
                            }
                        })
                    })
                    .catch(function (error) {
                        console.error('Service Worker registration failed:', error)
                    })
            }
        },
    },
    created() {
        this.ring = new Audio('/sounds/intercom_ring.wav')
        this.emergencyAlertRing = new Audio('/sounds/emergency-alarm.mp3')
        // this.ring.loop = true
    },
    mounted() {
        if (!!this.currentWorkplace) {
            this.listen()
        }
        this.registerSericeWorker()
    },
}
function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/')

    const rawData = window.atob(base64)
    const outputArray = new Uint8Array(rawData.length)

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
    }
    return outputArray
}
</script>
